export enum ExternalPermissionEnum {
  AssignmentTitle = 1,
  AssignmentDescription = 2,
  AssignmentReport = 3,
  AssignmentInternal = 4,
  AssignmentOrdererName = 5,
  AssignmentOrdererPhone = 6,
  AssignmentOrdererEmail = 7,
  AssignmentItems = 8,
  AssignmentFiles = 9,
  AssignmentWorkers = 10,
  AssignmentPerformedWorks = 11,
  AssignmentStatusLog = 12,
  AssignmentPerform = 13,
  AssignmentComments = 14,
  AssignmentType = 15,
  AssignmentCalculatedState = 16,
  AssignmentTarget = 17,
}

export enum ExternalPasswordStyle {
  Numbers = 2001,
  Characters = 2002,
  NumbersAndCharacters = 2003,
}

